/* jshint -W071 */
angular.module('core')
  .service('timeframe', ['translateFilter', '$state', 'moment', 'configuration', '$rootScope', function (translateFilter, $state, $moment, $configuration, $rootScope) {

      var TIMEFRAME_CUSTOM = 'custom';
      var TIMEFRAME_CUSTOM_SUMMER = 'custom-summer';
      var IS_DEFAULT_TIMEFRAME_MODE = 'defaultTfMode';

      // An rxjs subject to guarantee an appropriate year list will be available for
      // components that require a timeframe.
      var _yearListSubject;

      // Update state params with update timeframe value without causing a refresh.
      var updateStateParams = function (timeframe, by, timeframeId) {
          var params = {
              'timeframe': timeframe,
              'by': by,
              'timeframeId': timeframeId
          };

          return $state.go('.', params,
           {
              location: 'replace',
              notify: false
          });
      };

      // Convert name to given suffix.
      var nameToSuffix = function (name) {
          switch (name) {
              case 'day':
                  return 'd';

              case 'year':
                  return 'y';
          }
      };

      // Convert suffix to logical name.
      var suffixToName = function (suffix) {
          switch (suffix) {
              case 'd':
                  return 'day';

              case 'y':
                  return 'year';
          }
      };

      // Return suffix for current query timeframe param.
      // i.e. ...&timeframe=60d --> 'd'
      var getSuffix = function (timeframe) {
          var ret = false;
          ['d', 'y'].forEach(function (suffix) {
              if (_.indexOf(timeframe, suffix) !== -1) {
                  ret = suffix;
                  return ret;
              }
          });

          return ret;
      };

      // Parse int value from query param
      // ...&timeframe=2012y --> 2012
      // ...&timeframe=60d   --> 60
      var parseNumber = function (name) {
          var timeframe = $state.params.timeframe;
          var requiredSuffixType = nameToSuffix(name);
          var suffixType = getSuffix(timeframe);
          if (!suffixType || requiredSuffixType !== suffixType) {
              return;
          }

          var value = _.first(timeframe.split(suffixType));
          if (!value) {
              return;
          }

          return parseInt(value);
      };

      var parseNumberByID = function (name, id) {
          var timeframe = id;
          var requiredSuffixType = nameToSuffix(name);
          var suffixType = getSuffix(timeframe);
          if (!suffixType || requiredSuffixType !== suffixType) {
              return;
          }

          var value = _.first(timeframe.split(suffixType));
          if (!value) {
              return;
          }

          return parseInt(value);
      };

      // Parse school year from query param.
      // If it doesn't specify a year (i.e. 2012y) return undefined.
      var getSchoolYear = function () {
          return parseNumber('year');
      };

      var getDays = function () {
          var days = parseNumber('day');
          // check isNaN because we get NaN on custom range
          return !isNaN(days) ? days : undefined;
      };

      var getCustomFromDate = function () {
        return $state.params.timeframe.substring(2, 10);
      };

      var getCustomToDate = function () {
        return $state.params.timeframe.substring(12, 20);
      };

      var isDefaultTimeframeMode = function () {
          return sessionStorage.getItem(IS_DEFAULT_TIMEFRAME_MODE);
      };

      var setDefaultTimeframeMode = function (defaultMode) {
          try {
              sessionStorage.setItem(IS_DEFAULT_TIMEFRAME_MODE, defaultMode);
          } catch(err) {
          }
      };

      var getDaysParam = function () {
          var days = getDays();
          // this return determines if we use the days param, not the value of the days param
          return (days === 7 || days === 30) ? days : undefined;
      };

      // Parse days from query param. 60d --> From date is set 60 days ago.
      // If it doesn't specify a day value (i.e. 60d ) return undefined.
      var getFromDate = function (numDays) {

          // if custom date range is used...
          if (isCustomRange() && numDays === undefined) {
              return getCustomFromDate();
          }

          // today date range fd same as td
          if ($state.params.timeframe === '1d') {
              return $moment().format('YYYYMMDD');
          }

          // if this week is selected return this week sunday
          if (isThisWeekParam()) {
              return $moment().startOf('week').format("YYYYMMDD");
          }

          var days = numDays || parseNumber('day');

          // Dropping sending of fd to g2 for JUST last 7 day calls
          // http://redmine/redmine/issues/49528 - EdEx and G2 differ in which days are "Last 7", resulting in status mismatches
          if (days === 7) {
              return undefined;
          }

          return ( days ) ? $moment().subtract(days, 'days').format('YYYYMMDD') : undefined;
      };

      // Parse days from query param. 60d --> To date is set to current moment
      // If it doesn't specify a day value (i.e. 60d ) return undefined.
      var getToDate = function () {

          // if custom date range is used...
          if (isCustomRange()) {
              return getCustomToDate();
          }

          // today date range fd same as td
          if ($state.params.timeframe === "1d") {
              return $moment().format('YYYYMMDD');
          }

          // aggregations are not up to date until today, so td is yesterday
          // return ( parseNumber('day') ) ? $moment().subtract(1, 'days').format('YYYYMMDD') : undefined;
          // http://redmine/redmine/issues/49722 - Drop "td" from EdEx calls to G2 for Last 7 and Last 30
          return undefined;
      };

      /**
       * @returns {boolean} true if getToDate is today.
       */
      var isUntilNow = function () {
          if ($moment().format('YYYYMMDD') === getToDate() || isThisWeekParam()) {
              return true;
          } else {
              return false;
          }
      };

      /**
       * @returns {boolean} true if the time frame is current week
       */
      var isThisWeekParam = function() {
          return ($state.params.timeframe === '0w');
      };

      var getTimeframeParams = function () {
          var params = {};

        //   params.by = getByData();
          var days = parseNumber('day');
          if (!isNaN(days)) {
              params.days = days;
          }

          if (params.days === undefined) {
            params.sy = getSchoolYear();
            params.fd = getFromDate();
            params.td = getToDate();
          }

          if (isUntilNow()) {
              params.untilNow = true;
          }

          return params;
      };

      /**
       * Returns true if timeframe includes the present moment. In other words,
       * if the timeframe is specified number of days, is the current school year,
       * or is a custom range that includes the current day.
       *
       * I was originally thinking this function should be called isUntilNow, but
       * that was already taken by the
       * function above which apparently is used to determine if the untilNow
       * parameter should be set on certain API calls.
       *
       **/
      var includesThePresent = function () {
          if (($moment().format('YYYYMMDD') === getToDate()) || isThisWeekParam()) {
              return true;
          }

          var parsedDay = parseNumber('day');
          if (parsedDay !== null && isFinite(parsedDay)) {
              return true;
          }

          return isCurrentSchoolYear();
      };

      var isCurrentSchoolYear = function () {
        var year = parseNumber('year');

        return year === calculateCurrentReportingYear();
      };

      /**
       * Return true if custom date range ending today or yesterday, or
       * days query or current school year.
       *
       * used to determine if we show the alerts section on student overview
       **/
      var isRecent = function () {
          if (isThisWeekParam()) {
              return true;
          }

          var today = $moment().format('YYYYMMDD');
          var yesterday = $moment().subtract(1, 'days').format('YYYYMMDD');

          if (isCustomRange()) {
            var toDate = getCustomToDate();

            return toDate === today || toDate === yesterday;
          } else if (isCurrentSchoolYear()) {
            return true;
          } else {
            var days = parseNumber('day');

            return days !== undefined;
          }
      };

      var getByData = function () {
          return $state.params.by;
      };

      var getPrettyFromDate = function (format) {
          var isYear = _.contains($state.params.timeframe, 'y');
          if (isYear) {
              var year = getSchoolYear();
              // School year starts on July 1st
              return $moment(year + '-07-01').format(format);
          }

          if (isCustomRange()) {
              var custom = $state.params.timeframe.substr(2, 8);
              return $moment(custom, 'YYYYMMDD').format(format);
          }

          if (isThisWeekParam()) {
              return $moment().startOf('week').format(format);
          }

          // today date range fd same as td
          if ($state.params.timeframe === "1d") {
              return $moment().format(format);
          }

          var days = parseNumber('day');
          return ( days ) ? $moment().subtract(days, 'days').format(format) : function () {
              console.warn('warning: no days set', days);
              return undefined;
          };
      };

      var getPrettyProficiency = function (mode) {
          var fractionMode = (mode === 'fractionMode');

          var prefix = fractionMode ? 'Standard Proficiency For ' : 'Proficiency For ';
          var yearPrefix = translateFilter('standards.' + (fractionMode ? 'standardProficiencyAsOf' : 'proficiencyAsOf'));

          var isYear = _.contains($state.params.timeframe, 'y');
          if (isYear) {
              var year = getSchoolYear();
              if (year !== calculateCurrentReportingYear()) {
                  return prefix + year;
              }
          }

          if (isCustomRange()) {
            var custom = $state.params.timeframe.substr(12, 8);
            return yearPrefix + $moment(custom, 'YYYYMMDD').format('LL');
          }

          // use reportDates.to_date instead of today date
          if($rootScope.reportDates) {
            return yearPrefix + $moment($rootScope.reportDates.to_date).format('LL');
          }

          return '';
      };

      var calculateCurrentReportingYear = function () {
          return calculateReportingYear($moment());
      };

      var calculateCurrentReportingYearParam = function () {
          return calculateCurrentReportingYear() + 'y';
      };

      var calculateReportingYear = function (moment) {
          var year = moment.year();
          var schoolYear = $configuration.getSchoolYearStart();

          if (!schoolYear || schoolYear.month === undefined || schoolYear.date === undefined) {
              console.error('no school year set in properties file');
          } else {
              var startDate = $moment("01-01-" + year.toString(), "MM-DD-YYYY").subtract(1, 'days');
              var endDate = $moment((schoolYear.month + 1) + "-" + (schoolYear.date) + "-" + year.toString(), "MM-DD-YYYY");
              var isInBetween = moment.isBetween(startDate, endDate); //NOTE: isBetween() is *exclusive* of start and end
              var theYear = (isInBetween) ? year - 1 : year;

              return theYear;
          }
      };

      /**
       *
       * @param value Optional.  If null or undefined then the timeframe param is used (if that's present).
       * @returns {boolean}
       */
      var isCustomRange = function (value) {
          value = value || $state.params.timeframe;

          // example custom timeframe: "fd20140815td20150401"
          return (value && value.match(/^fd\d{8}td\d{8}$/)) ? true : false;
      };

      var isCustomSummerRange = function () {
          return $state.params.timeframeId === TIMEFRAME_CUSTOM_SUMMER;
      };

      var getFirstSchoolDateForYear = function (year) {
          var schoolYearStartConfig = $configuration.getSchoolYearStart();

          return $moment({
              y: year,
              M: schoolYearStartConfig.month,
              d: schoolYearStartConfig.date
          });
      };

      /**
       * @param years {Array} Null-safe.  Can be empty.  Array of years, as strings or numbers.
       * @returns {*} Year
       */
      var calculateEarliestCustomSchoolYear = function (years) {
          var safeYears = calculateAvailableCustomSchoolYears(years);
          return safeYears[0];
      };

      /**
       * @param years {Array} Null-safe.  Can be empty.  Array of years, as strings or numbers.
       * @returns {Array} Sorted list of school years available to custom date range.  Assume a non-null return
       *     with at least one value.
       */
      var calculateAvailableCustomSchoolYears = function (years) {
          if (!years || !years.length) {
              years = [calculateCurrentReportingYear()];
          }

          return years.sort();
      };

      /**
       * @param years {Array} Null-safe.  Can be empty.  Array of years, as strings or numbers.
       * @param moment Optional.  If null, defaults to maxPossibleDate. Used to determine the school year.
       * @param momentFrom Optional.  If null, defaults to the first day available in the school year, determined
       *                   by _moment_.  Used to determine the minimum To date.
       * @param allowCurrentDate Optional. If null yesterday will be the maxPossibleDate.
       * @returns {from: {min: , max: , defaultValue: }, to: {min: , max: , defaultValue: }}
       */
      var calculateCustomMinMax = function (years, moment, momentFrom, allowCurrentDate) {

          // setting maxPossibleDate to yesterday
          var maxPossibleDate = $moment().subtract(1, 'days').startOf('day');
          // setting maxPossibleDate to today
          if (allowCurrentDate) {
              maxPossibleDate = $moment().startOf('day');
          }
          moment = moment || maxPossibleDate;

          var schoolYear = calculateReportingYear(moment);
          var schoolYearStart = $configuration.getSchoolYearStart();
          var firstSchoolDay = $moment((schoolYearStart.month + 1) + "-" + (schoolYearStart.date) + "-" + schoolYear.toString(), "MM-DD-YYYY");
          var lastSchoolDay = $moment((schoolYearStart.month + 1) + "-" + (schoolYearStart.date) + "-" + (schoolYear + 1).toString(), "MM-DD-YYYY")
            .subtract(1, 'days');
          var earliestYear = calculateEarliestCustomSchoolYear(years);

          //minFrom never changes based on input -- it's always based on earliest school year available in reports
          var minFrom = $moment((schoolYearStart.month + 1) + "-" + (schoolYearStart.date) + "-" + earliestYear.toString(), "MM-DD-YYYY");

          //maxFrom is always maxPossibleDate
          var maxFrom = maxPossibleDate;

          //defaultFrom is 30 days ago, or the first day of the school year -- whichever is later
          var defaultFrom = $moment.max(firstSchoolDay, $moment(maxPossibleDate).subtract(29, 'days'));

          //minTo needs to change based on the currently selected From date.
          if (!momentFrom) {
              momentFrom = firstSchoolDay;
          }
          var minTo = momentFrom;

          //maxTo is always in the same school year as minTo, and is either maxPossibleDate or the last day of school (i.e. June 30th)
          var maxTo = ( maxPossibleDate.isBefore(lastSchoolDay) ? maxPossibleDate : lastSchoolDay );

          return {
              from: {min: minFrom, max: maxFrom, defaultValue: defaultFrom},
              to: {min: minTo, max: maxTo, defaultValue: maxTo}
          };
      };

      var calculateCustomSummerMinMax = function (currentFrom, currentDate, allowCurrentDate) {
          var startOfSchoolThisYear = getFirstSchoolDateForYear(currentDate.year());
          var startOfSummer = $moment(startOfSchoolThisYear).subtract(2, 'months');
          var endOfSummer = $moment(startOfSchoolThisYear).add(3, 'months').subtract(1, 'day');

          var currentDateBasedMax = allowCurrentDate ? $moment(currentDate).startOf('day') : $moment(currentDate).subtract(1, 'day').startOf('day');

          // show previous summer until we reach the first viewable day of the new summer
          if (currentDateBasedMax.isBefore(startOfSummer)) {
              startOfSummer.subtract(1, 'year');
              endOfSummer.subtract(1, 'year');
          }

          var maxTo = $moment.min(currentDateBasedMax, endOfSummer);

          return {
            from: {
                min: startOfSummer,
                max: maxTo,
                defaultValue: startOfSummer
            },
            to: {
                min: currentFrom || startOfSummer,
                max: maxTo,
                defaultValue: maxTo
            }
          };
      };

      var containsTimeframe = function (timeframes) {
          var contains = _.some(timeframes, 'id', $state.params.timeframe);
          if (contains) {
              return true;
          } else {
              return false;
          }
      };

      var isValidCustomRange = function (years, currentDate, allowCurrentDate) {
          var result = false;

          if (isCustomRange()) {
              result = true;

              var overrideFrom = $moment(getFromDate(), 'YYYYMMDD');
              var overrideTo = $moment(getToDate(), 'YYYYMMDD');
              var minMax;

              if (isCustomSummerRange()) {
                minMax = calculateCustomSummerMinMax(overrideFrom, currentDate, allowCurrentDate);
              } else {
                minMax = calculateCustomMinMax(years, overrideFrom, overrideFrom, allowCurrentDate);
              }

              if (minMax.from.min.isAfter(overrideFrom) ||
                minMax.from.max.isBefore(overrideFrom) ||
                minMax.to.min.isAfter(overrideTo) ||
                minMax.to.max.isBefore(overrideTo) ||
                overrideTo.isBefore(overrideFrom)) {
                  result = false;
              }
          }

          return result;
      };

      var isYearParam = function (timeframeParam) {
          if (!_.isString(timeframeParam)) {
              return false;
          }

          return !!timeframeParam.match(/[0-9]{4}y/);
      };

      /**
       * @returns the number of days between "from" and "to" dates passed by the server.
       * -1 if no dates are passed by the server
       */
      var getDaysInSelectedPeriod = function() {
          if ($rootScope.reportDates) {
              var from = $moment($rootScope.reportDates.from_date);
              var to = $moment($rootScope.reportDates.to_date);
              return to.diff(from, "days") + 1;
          }
          return -1;
      };

      /**
       * Returns earliest date (moment) in timeframe including school year timeframes.
       */
      var getFromDateForAnyTimeframe = function() {
          var from;

          if (isCustomRange()) {
              from = $moment(getCustomFromDate(), 'YYYYMMDD');
          } else if (isYearParam($state.params.timeframe)) {
              var schoolYearRange = getSchoolYearRangeMoments();
              from = schoolYearRange[0];
          } else if (parseNumber('day')) {
              from = $moment().startOf('day').subtract(parseNumber('day'), 'days');
          } else if (isThisWeekParam()) {
              from = $moment().startOf('week');
          }

          return from;
      };
    var getToDateForAnyTimeframe = function() {
      var to;

      if (isCustomRange()) {
        to = $moment(getCustomToDate(), 'YYYYMMDD');
      } else if (isYearParam($state.params.timeframe)) {
        var schoolYearRange = getSchoolYearRangeMoments();
        to = schoolYearRange[1];
      } else if (parseNumber('day')) {
        to = $moment().startOf('day').subtract(1, 'days');
      } else if (isThisWeekParam()) {
        to = $moment().startOf('day').subtract(1, 'days');
      }

      return to;
    };

      var isWithinDays = function (daysAgo) {
          var daysAgoMoment = $moment().startOf('day').subtract(daysAgo, 'days');
          var from = getFromDateForAnyTimeframe();

          if (from) {
            return !from.isBefore(daysAgoMoment);
          } else {
            return false;
          }
      };

      var getSchoolYearRangeMoments = function () {
          var schoolYearStart = $configuration.getSchoolYearStart();
          var from = $moment([getSchoolYear(), schoolYearStart.month, schoolYearStart.date]);
          var to = $moment([getSchoolYear() + 1, schoolYearStart.month, schoolYearStart.date]).subtract(1, 'days');

          return [from, to];
      };

      /**
       * Returns and object representing the current timeframe restricted to within a certain number
       * of days before present.
       **/
      var getTimeframeWithinDays = function (daysAgo) {
          var daysAgoMoment = $moment().startOf('day').subtract(daysAgo, 'days');
          var timeframe = {
              days: '',
              fd: undefined,
              td: undefined
          };

          var days = parseNumber('day');
          if (days) {
              timeframe.days = Math.min(days, daysAgo) + '';
          } else if (isThisWeekParam()) {
              timeframe.fd = $moment().startOf('week').format("YYYYMMDD");
              timeframe.td = $moment().startOf('day').format("YYYYMMDD");
          } else if (isCustomRange() || isYearParam($state.params.timeframe)) {
              var from;
              var to;

              if (isCustomRange()) {
                  from = $moment(getCustomFromDate(), 'YYYYMMDD');
                  to = $moment(getCustomToDate(), 'YYYYMMDD');
              } else if (isYearParam($state.params.timeframe)) {
                  var schoolYearRange = getSchoolYearRangeMoments();
                  from = schoolYearRange[0];
                  to = schoolYearRange[1];
              }

              if (from.isBefore(daysAgoMoment)) {
                  from = daysAgoMoment;
              }

              if (from.isAfter(to)) {
                return undefined;
              }

              timeframe.fd = from.format('YYYYMMDD');
              timeframe.td = to.format('YYYYMMDD');
          }

          return timeframe;
      };

      var getYearListSubject = function () {
        return _yearListSubject;
      };

      var setYearListSubject = function (yearListSubject) {
        _yearListSubject = yearListSubject;
      };

      return {
          TIMEFRAME_CUSTOM: TIMEFRAME_CUSTOM,
          updateStateParams: updateStateParams,
          parseNumber: parseNumber,
          parseNumberByID: parseNumberByID,
          getSchoolYear: getSchoolYear,
          getFromDate: getFromDate,
          getToDate: getToDate,
          getDays: getDays,
          getDaysParam : getDaysParam,
          getByData: getByData,
          getPrettyFromDate: getPrettyFromDate,
          getPrettyProficiency: getPrettyProficiency,
          getTimeframeWithinDays: getTimeframeWithinDays,
          getTimeframeParams: getTimeframeParams,
          getYearListSubject: getYearListSubject,
          calculateCurrentReportingYear: calculateCurrentReportingYear,
          calculateReportingYear: calculateReportingYear,
          calculateCurrentReportingYearParam: calculateCurrentReportingYearParam,
          calculateEarliestCustomSchoolYear: calculateEarliestCustomSchoolYear,
          calculateCustomMinMax: calculateCustomMinMax,
          calculateCustomSummerMinMax: calculateCustomSummerMinMax,
          isCustomRange: isCustomRange,
          isCustomSummerRange: isCustomSummerRange,
          includesThePresent: includesThePresent,
          isRecent: isRecent,
          isWithinDays: isWithinDays,
          isUntilNow: isUntilNow,
          containsTimeframe: containsTimeframe,
          isValidCustomRange: isValidCustomRange,
          isYearParam: isYearParam,
          getDaysInSelectedPeriod: getDaysInSelectedPeriod,
          setYearListSubject: setYearListSubject,
          isDefaultTimeframeMode: isDefaultTimeframeMode,
          setDefaultTimeframeMode: setDefaultTimeframeMode,
          getToDateForAnyTimeframe: getToDateForAnyTimeframe,
          getFromDateForAnyTimeframe:getFromDateForAnyTimeframe
      };

  }]);
/* jshint +W071 */
